class ReadMore extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      readMoreText: '[js-read-more-text]',
      readMoreButton: '[js-read-more-toggle]'
    }
  }

  connectedCallback() {
    this.readMoreButton = this.querySelector(this._selectors.readMoreButton);
    this.readMoreText = this.querySelector(this._selectors.readMoreText);

    this._setListeners();
    this._initReadMore();
    this._watchWindowResize();
  }

  _setListeners() {
    this.readMoreButton.addEventListener('click', this._handleReadMoreToggle);
  }

  _initReadMore() {
    if ((this.readMoreText.offsetHeight + 12) < this.readMoreText.scrollHeight) {
      this.readMoreButton.classList.remove('hidden');
    } else {
      this.readMoreButton.classList.add('hidden');
    }
  }

  _handleReadMoreToggle = (evt) => {
    const readMoreTextClasses = this.readMoreText;
    let currentReadMoreText = this.readMoreButton.innerText;

    this.readMoreButton.innerText = currentReadMoreText.toLowerCase() == 'read more' ? 'show less' : 'read more';
    this.readMoreText.toggleAttribute('data-hidden')
    if (this.readMoreText.getAttribute('data-hidden') === null) {
      this.readMoreText.focus();
    }
  }

  _watchWindowResize = evt => {
    window.addEventListener('resize', this._initReadMore.bind(this));
  }

}

customElements.define('read-more', ReadMore);